var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("AppBreadCrumb", {
        attrs: {
          paths: [{ title: _vm.$t("message.integrationsPage.copilotPrompts") }],
          select: true,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "copilot-prompts-page-wrapper" },
        [
          _c("CoPilotPrompts", {
            attrs: { saveCopilotPrompts: _vm.saveCopilotPrompts },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }